/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useSyncExternalStore } from "react";
import { generateUUID } from "common/utils/uuid";

const DEFAULT_DURATION_MS = 5000;
const MAX_VISIBLE_TOASTS = 5;

// Module-level singleton state (matches Vue's module-level ref)
let toasts: any[] = [];
const listeners = new Set<() => void>();

function emitChange() {
  listeners.forEach(l => l());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return toasts;
}

function addToast({
  title,
  description,
  variant = "default",
  duration = DEFAULT_DURATION_MS
}: any) {
  const id = generateUUID();

  toasts = [
    ...toasts.slice(-(MAX_VISIBLE_TOASTS - 1)),
    { id, title, description, variant, removing: false }
  ];
  emitChange();

  if (duration > 0) {
    setTimeout(() => dismissToast(id), duration);
  }

  return id;
}

function dismissToast(id: any) {
  toasts = toasts.map(t => (t.id === id ? { ...t, removing: true } : t));
  emitChange();

  // Remove from DOM after exit animation
  setTimeout(() => {
    toasts = toasts.filter(t => t.id !== id);
    emitChange();
  }, 300);
}

function clearAll() {
  toasts = [];
  emitChange();
}

// eslint-disable-next-line import/prefer-default-export
export function usePinningToast() {
  const currentToasts = useSyncExternalStore(subscribe, getSnapshot);

  return {
    toasts: currentToasts,
    dismiss: dismissToast,
    clearAll,
    toast: (props: any) => addToast(props),
    success: (props: any) => addToast({ ...props, variant: "success" }),
    error: (props: any) => addToast({ ...props, variant: "error" }),
    warning: (props: any) => addToast({ ...props, variant: "warning" }),
    info: (props: any) => addToast({ ...props, variant: "info" })
  };
}
